/**
 * Translations for the site.
 *
 * - `hy` (Armenian) is the source language and the fallback: if a key is
 * missing or empty in another language, the Armenian value is used.
 * - Fill in the `en` and `ru` objects with the matching strings. The keys are
 * already laid out for you — just put the translated text between the quotes.
 *
 * Keys are flat dotted strings (e.g. "hero.title") so the file stays easy to
 * scan and edit.
 */

const hy = {
    // Navigation / header
    "nav.about": "Մեր մասին",
    "nav.volunteers": "Կամավորներ",
    "nav.organizations": "Կազմակերպություններ",
    "nav.events": "Միջոցառումներ",
    "nav.becomePartner": "Դառնալ գործընկեր",
    "nav.download": "Ներբեռնել",

    // Download buttons
    "download.appStore.small": "Ներբեռնեք",
    "download.googlePlay.small": "Հասանելի է",

    // Hero
    "hero.eyebrow": "Կամավորության ազգային էկոհամակարգ",
    "hero.title": "Կամավորների ազգային հարթակ",
    "hero.subtitle":
        "Միջոցառումներ, մրցանակներ, հնարավորություններ՝ քո գրպանում։ Ներբեռնի՛ր հավելվածը և միացի՛ր Հայաստանի կամավորների համայնքին։",
    "hero.platforms": "Հասանելի է iOS և Android սարքերի համար",

    // Benefits
    "benefits.eyebrow": "Ինչու՞ մենք",
    "benefits.heading": "Ինչու՞ ընտրել մեր հավելվածը",
    "benefits.sub":
        "Ստեղծված է կամավորների համար՝ պարզ, արագ և մոտիվացնող փորձառությամբ։",
    "benefits.allInOne.title": "Ամեն ինչ մեկ տեղում",
    "benefits.allInOne.text":
        "Բոլոր կամավորությունները, միջոցառումներն ու հնարավորությունները՝ մեկ հավելվածում։",
    "benefits.coins.title": "CTRL մետաղադրամներ",
    "benefits.coins.text":
        "Մասնակցի՛ր, հավաքի՛ր մետաղադրամներ և բարձրացրու՛ քո մակարդակը։",
    "benefits.notify.title": "Ակնթարթային ծանուցումներ",
    "benefits.notify.text":
        "Իմացի՛ր նոր միջոցառումների մասին առաջինը՝ ուղիղ քո հեռախոսին։",
    "benefits.trust.title": "Թափանցիկ և վստահելի",
    "benefits.trust.text":
        "Ստուգված կազմակերպություններ և թափանցիկ կամավորական պատմություն։",
    "benefits.community.title": "Ակտիվ համայնք",
    "benefits.community.text": "Միացի՛ր հազարավոր կամավորների և գտի՛ր քո թիմը։",
    "benefits.fast.title": "Արագ և անվճար",
    "benefits.fast.text": "Գրանցվի՛ր մի քանի վայրկյանում՝ լիովին անվճար։",

    // Features carousel
    "features.eyebrow": "Հնարավորություններ",
    "features.heading": "Ի՞նչ կարող ես անել հավելվածով",
    "features.discover.title": "Գտի՛ր քո կամավորությունը",
    "features.discover.text":
        "Որոնի՛ր և գտի՛ր քեզ հարմար կամավորությունները՝ ըստ վայրի, ոլորտի և քո հետաքրքրությունների։",
    "features.discover.screen": "Որոնում",
    "features.progress.title": "Հետևի՛ր քո առաջընթացին",
    "features.progress.text":
        "Հավաքի՛ր CTRL մետաղադրամներ և բարձրացրու՛ քո մակարդակը յուրաքանչյուր մասնակցությամբ։",
    "features.progress.screen": "Իմ պրոֆիլը",
    "features.notify.title": "Ակնթարթային ծանուցումներ",
    "features.notify.text":
        "Իմացի՛ր նոր միջոցառումների մասին առաջինը՝ ծանուցումներ ուղիղ քո հեռախոսին։",
    "features.notify.screen": "Ծանուցումներ",
    "features.community.title": "Միացի՛ր համայնքին",
    "features.community.text":
        "Գտի՛ր թիմեր, համագործակցի՛ր և ստացի՛ր ճանաչում քո ներդրման համար։",
    "features.community.screen": "Համայնք",

    // App showcase
    "showcase.eyebrow": "Հավելվածը",
    "showcase.heading": "Քո կամավորական ուղին՝ քո գրպանում",
    "showcase.desc":
        "CTRL Events հավելվածը միավորում է կամավորներին և կազմակերպություններին մեկ պարզ ու հարմար միջավայրում։",
    "showcase.feature.discover": "Գտի՛ր կամավորություններ քո մոտակայքում",
    "showcase.feature.progress": "Հետևի՛ր քո առաջընթացին և մակարդակին",
    "showcase.feature.notify": "Ստացի՛ր ծանուցումներ նոր միջոցառումների մասին",
    "showcase.feature.community": "Միացի՛ր թիմերին և ստացի՛ր ճանաչում",

    // Footer
    "footer.tagline": "Կամավորների և կազմակերպությունների ազգային հարթակ։",
    "footer.col.platform": "Հարթակ",
    "footer.col.legal": "Իրավական",
    "footer.col.social": "Հետևե՛ք մեզ",
    "footer.copyright": "CTRL Events Volunteering",
    "legal.terms": "Օգտագործման պայմաններ",
    "legal.privacy": "Գաղտնիության քաղաքականություն",
    "legal.agreement": "Կամավորի համաձայնագիր",
    "legal.feedback": "Հետադարձ կապ",

    // Volunteers page
    "volunteers.title": "Կամավորներ",
    "volunteers.intro":
        "Սա այն վայրն է, որտեղ միավորվում են Հայաստանի ակտիվ քաղաքացիները՝ մասնակցելու իրական փոփոխություններին։ Այստեղ դուք կարող եք ստեղծել պրոֆիլ, միանալ ծրագրերին և ստանալ առաջխաղացում ձեր կամավորական ճանապարհին",
    "volunteers.progress.title": "Պրոգրես",
    "volunteers.progress.text":
        "Յուրաքանչյուր կամավոր ունի իր առաջխաղացման, իր մակարդակի սանդղակը։ Ամեն անգամ կամավորության մասնակցելիս կամավորը ստանում է CTRL coins որը ամեն հարյուրյակը անցնելիս կփոխի կամավորի մակարդակը։ Այս համակարգը ստեղծում է մոտիվացիա էլ ավելի շատ կամավորությունների մասնակցելու։",
    "volunteers.top.title": "Մեր լավագույն կամավորները",
    "volunteers.top.text":
        "Դու կարող ես լինել նրանցից մեկը։ Մենք սպասում ենք քեզ",
    "volunteers.coins": "CTRL coins-",
    "volunteers.error": "Չհաջողվեց բեռնել կամավորներին։",
    "volunteers.empty": "Դեռ չկան կամավորներ։ Եղի՛ր առաջինը։",
    "volunteers.cta": "Ներբեռնել հավելվածը",

    // Feedback page
    "feedback.title": "Հետադարձ կապ",
    "feedback.lead":
        "Ունե՞ք հարց կամ առաջարկ։ Գրեք մեզ, և մենք կկապվենք ձեզ հետ։",
    "feedback.success": "Շնորհակալություն։ Ձեր հաղորդագրությունն ուղարկվեց։",
    "feedback.name": "Անուն Ազգանուն",
    "feedback.name.required": "Խնդրում ենք լրացնել անունը",
    "feedback.phone": "Հեռախոսահամար",
    "feedback.phone.required": "Խնդրում ենք լրացնել հեռախոսահամարը",
    "feedback.phone.invalid": "Անվավեր հեռախոսահամար",
    "feedback.email": "Email",
    "feedback.email.required": "Խնդրում ենք լրացնել email-ը",
    "feedback.email.invalid": "Անվավեր email հասցե",
    "feedback.message": "Հաղորդագրություն",
    "feedback.message.required": "Խնդրում ենք գրել հաղորդագրությունը",
    "feedback.message.placeholder": "Ձեր հաղորդագրությունը...",
    "feedback.policy": "Ես կարդացել և ընդունում եմ",
    "feedback.policy.link": "գաղտնիության քաղաքականությունը",
    "feedback.policy.required": "Անհրաժեշտ է ընդունել պայմանները",
    "feedback.submit": "Ուղարկել",
    "feedback.error": "Չհաջողվեց ուղարկել։ Խնդրում ենք կրկին փորձել։",

    // Organization registration (Become a partner form)
    "org.title": "Կազմակերպության գրանցում",
    "org.lead": "Լրացրե՛ք ձևը, և մենք կկապվենք ձեզ հետ գործընկերության շուրջ։",
    "org.orgName": "Կազմակերպության անվանումը",
    "org.orgName.required": "Նշե՛ք կազմակերպության անվանումը",
    "org.contactName": "Կոնտակտային անձ",
    "org.contactName.required": "Նշե՛ք կոնտակտային անձին",
    "org.email": "Էլ. հասցե",
    "org.email.required": "Նշե՛ք էլ. հասցեն",
    "org.email.invalid": "Սխալ էլ. հասցե",
    "org.phone": "Հեռախոսահամար",
    "org.phone.required": "Նշե՛ք հեռախոսահամարը",
    "org.phone.invalid": "Սխալ հեռախոսահամար",
    "org.city": "Քաղաք",
    "org.website": "Կայք",
    "org.description": "Կազմակերպության մասին",
    "org.description.placeholder": "Համառոտ նկարագրեք ձեր գործունեությունը",
    "org.submit": "Ուղարկել հայտը",
    "org.success": "Շնորհակալություն։ Ձեր հայտն ուղարկվեց։",
    "org.error": "Չհաջողվեց ուղարկել։ Խնդրում ենք կրկին փորձել։",

    // Other page titles
    "page.about.title": "Մեր մասին",
    "page.organizations.title": "Կամավորական կազմակերպություններին",
    "page.events.title": "Միջոցառումներ",
    "page.becomePartner.title": "Դառնալ գործընկեր",

    // About page — mission + FAQ
    "about.intro.p1":
        "Մենք ստեղծում ենք առաջին միասնական, ժամանակակից և բաց հարթակը, որը միավորում է Հայաստանի բոլոր կամավորներին և կամավորություն տրամադրող կազմակերպություններին։ Մեր նպատակն է կառուցել վստահելի, թափանցիկ և ներգրավող միջավայր, որտեղ յուրաքանչյուր մարդ կարող է գտնել իր տեղը՝ օգնելու, զարգանալու և ազդեցություն թողնելու համար։ Մենք հավատում ենք, որ կամավորությունը ոչ միայն բարեգործական քայլ է, այլ մշակույթ, որը ձևավորում է ուժեղ հասարակություն։",
    "about.intro.items": [
        "իրական նախագծերի,",
        "ստանալու ճանաչում և գնահատում իրենց աշխատանքի համար,",
        "զարգացնելու հմտություններ և փորձ,",
        "միանալու նախաձեռնություններին՝ տեղական և միջազգային մակարդակներում։",
    ],
    "about.intro.p2":
        "Մեր թիմը աշխատում է այն գաղափարի վրա, որ յուրաքանչյուր մարդ կարող է փոխել աշխարհը անգամ փոքր քայլերով։ Մենք կառուցում ենք համակարգ, որտեղ նորեկները հեշտությամբ գտնում են իրենց առաջին փորձը, իսկ փորձառու կամավորները կարող են առաջ գնալ, դառնալ թիմի ղեկավարներ կամ ներգրավվել մեծ նախագծերում։ Մեր տեսլականն է ստեղծել կենսունակ կամավորական համայնք, որը կխթանի սոցիալական պատասխանատվությունը, նորարարությունը և փոխօգնության մշակույթը։ Միացեք մեզ՝ կառուցելու ուժեղ, հոգատար և նախաձեռնող Հայաստան։",
    "about.faqTitle": "Հաճախ տրվող հարցեր",
    "about.faq": [
        {
            q: "Ո՞րն է ձեր հարթակի հիմնական նպատակը։",
            a: "Մեր հարթակի հիմնական նպատակն է ստեղծել միասնական էկոհամակարգ՝ կամավորներին և կազմակերպություններին իրար կապելու, կամավորական մշակույթը խթանելու և սոցիալական պատասխանատվությունը բարձրացրելու համար։",
        },
        {
            q: "Ու՞մ համար է նախատեսված հարթակը։",
            a: "Հարթակը նախատեսված է Հայաստանի բոլոր ակտիվ քաղաքացիների, ուսանողների, երիտասարդների, ինչպես նաև հասարակական և կամավորական կազմակերպությունների համար, ովքեր ձգտում են մասնակցել իրական փոփոխությունների։",
        },
        {
            q: "Ի՞նչպես կարող եմ գրանցվել որպես կամավոր։",
            a: "Պարզապես ներբեռնեք CTRL Events հավելվածը App Store-ից կամ Google Play-ից, ստեղծեք ձեր պրոֆիլը և դուք կստանաք մուտք դեպի բոլոր ակտիվ կամավորական հնարավորությունները։",
        },
        {
            q: "Կարող եմ արդյոք դառնալ թիմլիդ կամ ղեկավարել նախագիծ։",
            a: "Այո՛, հարթակը խրախուսում է աճը։ Որքան շատ մասնակցեք միջոցառումների և հավաքեք CTRL մետաղադրամներ, այնքան բարձր կլինի ձեր մակարդակը, ինչը թույլ կտա ձեզ ստանձնել ավելի պատասխանատու դերեր, օրինակ՝ թիմի ղեկավարի։",
        },
        {
            q: "Ի՞նչպես կարող եմ գրանցվել որպես կամավոր։",
            a: "Գրանցումը կատարվում է անմիջապես հավելվածում՝ նույնականացման պարզ ընթացակարգով։",
        },
        {
            q: "Ի՞նչպես կարող է կազմակերպությունը համագործակցել ձեզ հետ։",
            a: "Կազմակերպությունները կարող են ավելացնել իրենց պրոֆիլը հարթակում «Դառնալ գործընկեր» բաժնի միջոցով։ Մեր թիմը կկապվի ձեզ հետ՝ հավելվածում ձեր միջոցառումներն ու կամավորական հաստիքները հրապարակելու գործընթացը սկսելու համար։",
        },
        {
            q: "Վճարովի՞ է մասնակցությունը։",
            a: "Ոչ, հարթակը լիովին անվճար է ինչպես կամավորների, այնպես էլ կազմակերպությունների համար։",
        },
        {
            q: "Կա՞ն մրցույթներ կամ պարգևներ կամավորների համար։",
            a: "Այո, մեր «CTRL coins» համակարգը հենց դրա համար է։ Մասնակցելով միջոցառումներին՝ դուք կուտակում եք միավորներ, որոնք բարձրացնում են ձեր մակարդակը։",
        },
        {
            q: "Ինչպե՞ս եք ապահովում ծրագրերի թափանցիկությունը։",
            a: "Մենք ստուգում ենք բոլոր գրանցված կազմակերպություններին։ Բացի այդ, յուրաքանչյուր կամավոր կարող է թողնել իր հետադարձ կապը՝ միջոցառումից հետո, ինչը ապահովում է պատշաճ որակ և պատասխանատվություն բոլոր կողմերից։",
        },
    ],

    // Organizations page
    "org.intro":
        "Մենք միավորում ենք Հայաստանի կամավորական ամբողջ էկոհամակարգը՝ ստեղծելով հարթակ, որտեղ ձեր կազմակերպությունը կարող է ավելի արդյունավետ աշխատել, հաճախորդները՝ ստանալ ավելի որակյալ աջակցություն, իսկ կամավորները՝ զարգանալ և դառնալ ավելի ուժեղ մասնագիտական ուժ։ Եթե ձեր կազմակերպությունն ունի կամավորներ, նախագծեր կամ միջոցառումներ, ապա մեր հարթակը նախատեսված է հենց ձեզ համար։",
    "org.whyTitle": "Ինչու միանալ մեր հարթակին",
    "org.why": [
        {
            label: "Միասնական կառավարման համակարգ",
            text: "Դուք կարող եք կառավարել ձեր ամբողջ կամավորական կառուցվածքը մեկ տեղից․ գրանցել կամավորներին, բաժանել նրանց թիմերի, հետևել նրանց մասնակցությանը և առաջընթացին, ստանալ հստակ հաշվետվություններ։",
        },
        {
            label: "Աճ ձեր համայնքի ներգրավվածության մեջ",
            text: "Մեր հարթակում դուք կարող եք․ ներգրավել նոր կամավորների, ներկայացնել ձեր ծրագրերը մեծ լսարանին, բարձրացնել ձեր կազմակերպության ճանաչելիությունը։",
        },
        {
            label: "Գործիքներ որոնք կխնայեն ձեր ժամանակը",
            text: "Ավտոմատացված հայտագրում, ժամանակացույց և աշխատանքային հոսքեր, հաղորդագրություններ կամավորների հետ, գնահատման և արձագանքների համակարգ, վկայականների օնլայն տրամադրում։",
        },
        {
            label: "Մասնակցություն ազգային նախաձեռնությանը",
            text: "Ձեր կազմակերպությունը դառնում է երկրի կամավորական շարժման մաս՝ կառուցելով միասնական մշակույթ, որտեղ օգնականները, նախաձեռնությունները և ծրագրերը կապվում են միմյանց հետ մեկ հարթակում։",
        },
        {
            label: "Դիտարկումներ և թափանցիկություն",
            text: "Այլ կազմակերպություններ և միջոցառումների կազմակերպիչներ կարող են տեսնել․ ձեր կազմակերպության արդյունավետությունը, ձեր կամավորների փորձը, ձեր իրականացրած նախագծերը։ Սա մեծացնում է ձեր հեղինակությունը և վստահությունը։",
        },
        {
            label: "Միջազգային հնարավորությունների մուտք",
            text: "Մենք ձևավորում ենք համագործակցություններ միջազգային կամավորական կառույցների հետ։ Մեր լավագույն կամավորներն ու թիմերի ղեկավարները կարող են մասնակցել միջազգային ծրագրերին՝ ներկայացնելով Հայաստանը։",
        },
    ],
    "org.goalTitle": "Մեր միասնական նպատակը",
    "org.goal":
        "Ստեղծել մի հարթակ, որտեղ կամավորական կազմակերպությունները կարող են աճել, համագործակցել, զարգացնել իրենց համայնքները և իրականացնել ավելի մեծ ազդեցություն, քան երբևէ։",
    "org.cta": "Ավելացնել իմ կազմակերպությունը",

    // Become a partner page
    "partner.intro":
        "Մենք կառուցում ենք ազգային կամավորական հարթակ, որը միավորում է հազարավոր մարդկանց, կազմակերպությունների և նախաձեռնությունների։ Եթե ձեր կազմակերպությունը կիսում է նույն արժեքները՝ աջակցություն, զարգացում և սոցիալական պատասխանատվություն, ապա մենք հրավիրում ենք միանալ մեր գործընկերների ցանցին։",
    "partner.whyTitle": "Ինչու լինել մեր գործընկերը",
    "partner.why": [
        {
            label: "Օգնել հազարավոր ակտիվ քաղաքացիների",
            text: "Մեր հարթակը միավորում է մեծ կամավորական համայնք՝ տարբեր ոլորտներից, հմտություններով և փորձով։",
        },
        {
            label: "Ուժեղացնել ձեր սոցիալական պատասխանատվությունը",
            text: "Գործընկերությունը թույլ է տալիս ձեր կազմակերպությանը ցույց տալ իրական, չափելի ներդրում համայնքի զարգացման գործում։",
        },
        {
            label: "Մասնակցել ազգային և միջազգային նախագծերի",
            text: "Գործընկերները ստանում են հնարավորություն միանալու համատեղ ծրագրերին, համաժողովներին և կամավորական արշավներին։",
        },
        {
            label: "Աջակցել նոր սերնդի կամավորներին",
            text: "Ձեր ներդրումը ուղղվում է․ նոր կամավորների կրթությանը, հմտությունների զարգացման ծրագրերին, մրցույթների և միջազգային փոխանակումների կազմակերպմանը,",
        },
        {
            label: "Բրենդային տեսանելիություն",
            text: "Գործընկերները նշվում են՝ հարթակում, միջոցառումների ժամանակ, կազմակեպչական նյութերում, մեդիա թողարկումներում։",
        },
        {
            label: "Սա բարձրացնում է ձեր կազմակերպության հեղինակությունը որպես սոցիալական արժեք ստեղծող կառույց։",
            text: "",
        },
    ],
    "partner.formsTitle": "Գործընկերության ձևերը",
    "partner.forms":
        "Ֆինանսական աջակցություն — ծրագրերի, մրցույթների կամ միջոցառումների ֆինանսավորում, Հովանավորչություն — մրցանակներ, կրթական ծրագրեր, միջազգային ուղևորություններ, Մասնագիտական աջակցություն — փորձով մասնագետներ, ուսուցում, վերապատրաստումներ, Տեղեկատվական աջակցություն — մեդիա տարածում, պատմությունների լուսաբանում, Համատեղ ծրագրեր — նախագծերի համաֆինանսավորում կամ համատեղ իրականացում։",
    "partner.cta": "Համագործակցել",

    // Events page
    "events.intro":
        "Սա մեր պորտֆոլիոն է։ Այստեղ դուք կարող եք տեսնել այն միջոցառումները որոնց մասնակցել են այս հարթակի կամավորները և կազմակերպությունները։",
    "events.seeMore": "Տեսնել ավելին",
    "events.cta": "Ներբեռնել հավելվածը",
    "eventDetail.back": "Բոլոր միջոցառումները",
    "eventDetail.notFound": "Միջոցառումը չի գտնվել",

    // Legal — common
    "legal.updated": "Վերջին թարմացում՝ 4 հուլիսի, 2026թ.",
    "terms.intro":
        "Բարի գալուստ «Ctrl Events»։ Սույն Օգտագործման պայմանները կարգավորում են ձեր մուտքն ու օգտագործումը վեբ-կայքի և բջջային հավելվածի:",
    "terms.sections": [
        {
            h: "1. Ծառայության նկարագրությունը",
            t: "«Ctrl Events»-ը միավորում է կամավորներին և կազմակերպություններին։ Հարթակը թույլ է տալիս գտնել աշխատանքներ, գրանցվել միջոցառումներին և կուտակել «CTRL» մետաղադրամներ։",
        },
        {
            h: "2. Օգտահաշիվ և Գրանցում",
            t: "Անհրաժեշտ է ստեղծել օգտահաշիվ՝ տրամադրելով ճշգրիտ տվյալներ։ Դուք եք պատասխանատու ձեր գաղտնաբառի անվտանգության համար։ Կեղծ օգտահաշիվների ստեղծումը արգելվում է։",
        },
        {
            h: "3. Վարքագծի կանոններ և Անթույլատրելի բովանդակություն",
            t: "Արգելվում է տեղադրել վիրավորական, ատելություն սերմանող կամ անպարկեշտ նյութեր: Բացարձակ անհանդուրժողականություն (Zero Tolerance). մենք առանց նախազգուշացման հեռացնում ենք անթույլատրելի բովանդակությունը և արգելափակում խախտողներին։",
        },
        {
            h: "4. Բողոքարկում և մոդերացիա (Reporting)",
            t: "Յուրաքանչյուր օգտատեր կարող է անմիջապես զեկուցել (report) վատ վարքագծի մասին: Մոդերատորները ուսումնասիրում են զեկույցները և կիրառում արգելափակումներ:",
        },
        {
            h: "5. Կամավորական գործունեության կազմակերպումը",
            t: "Աշխատանքը անհատույց է: Միջոցառումները կառավարվում են ուղղակիորեն «ՔՈՆԹՐՈԼ ԻՎԵՆԹՍ» ՀԿ-ի կողմից (որտեղ կրում ենք ամբողջական պատասխանատվություն) կամ երրորդ կողմի միջոցով, որտեղ հարթակը միայն միջնորդ է:",
        },
        {
            h: "6. Մտավոր սեփականություն",
            t: "Դիզայնը, տեքստերը, լոգոները և կոդը մեր մտավոր սեփականությունն են։ Պատճենումը առանց գրավոր թույլտվության արգելվում է։",
        },
        {
            h: "7. Պայմանների փոփոխություններ",
            t: "Մենք իրավունք ունենք պարբերաբար թարմացնել պայմանները։ Շարունակական օգտագործումը նշանակում է նոր պայմանների ընդունում։",
        },
        {
            h: "8. Հաշվի դադարեցում",
            t: "Դուք կարող եք ջնջել ձեր օգտահաշիվը կարգավորումներից։ Մենք նույնպես կարող ենք կասեցնել այն պայմանները խախտելու դեպքում։",
        },
        {
            h: "9. Կապ մեզ հետ",
            t: "Հարցերի դեպքում կապ հաստատեք. info.ctrlvolunteering@gmail.com",
        },
    ],

    // Privacy policy
    // Privacy policy
    "privacy.intro":
        "Այս Գաղտնիության քաղաքականությունը բացատրում է, թե ինչպես ենք մենք հավաքագրում, մշակում, պահպանում և պաշտպանում ձեր անձնական տվյալները «Ctrl Events» հարթակն օգտագործելիս։",
    "privacy.sections": [
        {
            h: "1. Որ տվյալներն ենք հավաքում",
            t: "Մենք հավաքագրում ենք այն տվյալները, որոնք դուք տրամադրում եք գրանցվելիս և հարթակն օգտագործելիս, մասնավորապես՝ անուն, ազգանուն, էլ. փոստի հասցե, հեռախոսահամար, ծննդյան ամսաթիվ, պրոֆիլի նկար, ինչպես նաև հարթակում ձեր գործողությունների և մասնակցած միջոցառումների պատմությունը։",
        },
        {
            h: "2. Տվյալների օգտագործման նպատակը",
            t: "Ձեր տվյալները օգտագործվում են հարթակի բնականոն աշխատանքն ապահովելու, կամավորական ծրագրերը ճիշտ համակարգելու, ձեզ ծանուցումներ ուղարկելու, աջակցություն տրամադրելու, ինչպես նաև վիճակագրական վերլուծությունների միջոցով մեր ծառայությունները բարելավելու համար։",
        },
        {
            h: "3. Տվյալների փոխանցում երրորդ անձանց",
            t: "Մենք խստորեն հարգում ենք ձեր գաղտնիությունը։ Ձեր անձնական տվյալները երբեք չեն վաճառվում երրորդ անձանց։ Դրանք կարող են փոխանցվել միջոցառման կազմակերպիչներին միայն ձեր մասնակցությունը հաստատելու նպատակով, կամ տրամադրվել իրավապահ մարմիններին՝ բացառապես ՀՀ օրենսդրությամբ պահանջվող դեպքերում։",
        },
        {
            h: "4. Տվյալների պաշտպանություն",
            t: "Մենք կիրառում ենք անվտանգության ժամանակակից միջոցներ (կոդավորում, անվտանգ սերվերներ)՝ ձեր տվյալները չարտոնված մուտքից, կորստից կամ հրապարակումից պաշտպանելու համար։",
        },
        {
            h: "5. Տվյալների պահպանում և ջնջում (Account Deletion)",
            t: "Ձեր տվյալները պահպանվում են այնքան ժամանակ, քանի դեռ ձեր օգտահաշիվը ակտիվ է: Դուք ցանկացած պահի կարող եք պահանջել ձեր օգտահաշվի և անձնական տվյալների ամբողջական ջնջում՝ հավելվածի կարգավորումների կամ մեզ ուղղված էլ. նամակի միջոցով։",
        },
        {
            h: "6. Ձեր իրավունքները",
            t: "Դուք իրավունք ունեք մուտք գործել ձեր տվյալներ, խմբագրել դրանք, սահմանափակել դրանց մշակումը կամ պահանջել ամբողջական ջնջում։ Դուք նաև իրավունք ունեք ցանկացած պահի հրաժարվել ծանուցումներից։",
        },
        {
            h: "7. Քաղաքականության փոփոխություններ",
            t: "Մենք կարող ենք պարբերաբար թարմացնել այս քաղաքականությունը։ Փոփոխություններն ուժի մեջ են մտնում կայքում կամ հավելվածում հրապարակվելու պահից։",
        },
        {
            h: "8. Կապ մեզ հետ",
            t: "Գաղտնիության քաղաքականության հետ կապված հարցերով կարող եք կապվել մեզ հետ՝ 📧 info.ctrlvolunteering@gmail.com հասցեով։",
        },
        {
            h: "9. Եզրափակիչ դրույթներ",
            t: "Սույն քաղաքականությունը գործում է Հայաստանի Հանրապետության «Անձնական տվյալների պաշտպանության մասին» օրենքի համաձայն։",
        },
    ],

    // Volunteer agreement
    // Volunteer agreement
    "agreement.intro":
        "Սույն Կամավորի համաձայնագիրը կարգավորում է կամավորի և «Ctrl Events» հարթակի, ինչպես նաև միջոցառումներ կազմակերպող կողմերի միջև հարաբերությունները։ Գրանցվելով որպես կամավոր՝ դուք ընդունում եք հետևյալ պայմանները։",
    "agreement.sections": [
        {
            h: "1. Ընդհանուր դրույթներ",
            t: "Կամավորական գործունեությունը իրականացվում է կամավորի ազատ կամքով, հանրօգուտ նպատակներով և առանց ֆինանսական վարձատրության ակնկալիքի։ Այն չի հանդիսանում աշխատանքային հարաբերություն ՀՀ աշխատանքային օրենսդրության իմաստով։",
        },
        {
            h: "2. Կամավորի իրավունքները",
            t: "Կամավորն իրավունք ունի նախապես ամբողջական տեղեկատվություն ստանալ կատարվելիք աշխատանքի բնույթի և պայմանների մասին, ցանկացած պահի հրաժարվել մասնակցությունից՝ նախապես տեղեկացնելով կազմակերպչին, ինչպես նաև ստանալ աշխատանքի գնահատական, վկայական կամ երաշխավորագիր։",
        },
        {
            h: "3. Կամավորի պարտականությունները",
            t: "Կամավորը պարտավորվում է ստանձնած աշխատանքը կատարել բարեխղճորեն, հետևել կազմակերպիչների և թիմի ղեկավարների ցուցումներին, պահպանել միջոցառման ժամանակացույցը և չվնասել կազմակերպության կամ միջոցառման հեղինակությունը։",
        },
        {
            h: "4. Անվտանգություն և պատասխանատվություն",
            t: "Կամավորը միջոցառումներին մասնակցում է սեփական պատասխանատվությամբ։ Հարթակը և կազմակերպիչները պարտավորվում են հնարավորինս ապահովել անվտանգ աշխատանքային պայմաններ, սակայն ուղղակի պատասխանատվություն չեն կրում կամավորի անզգուշության կամ կանոնների խախտման հետևանքով առաջացած վնասների համար։",
        },
        {
            h: "5. Վարքագծի կանոններ",
            t: "Կամավորը պարտավոր է պահպանել էթիկայի նորմերը, հարգալից վերաբերմունք ցուցաբերել այլ կամավորների, կազմակերպիչների և շահառուների նկատմամբ։ Խստիվ արգելվում է ալկոհոլի կամ թմրանյութերի ազդեցության տակ գտնվելը և հասարակական կարգը խախտելը։",
        },
        {
            h: "6. Անձնական տվյալներ",
            t: "Կամավորի անձնական տվյալները հավաքագրվում և մշակվում են խիստ համաձայն մեր Գաղտնիության քաղաքականության՝ բացառապես կամավորական ծրագրերի և միջոցառումների կազմակերպման նպատակով։",
        },
        {
            h: "7. Լուսանկարներ և նյութեր",
            t: "Մասնակցելով միջոցառումներին՝ կամավորը համաձայնում է, որ իր մասնակցությամբ արված լուսանկարներն ու տեսանյութերը կարող են օգտագործվել հարթակի և կազմակերպիչների կողմից՝ տեղեկատվական, կրթական և ոչ առևտրային նպատակներով։",
        },
        {
            h: "8. Համաձայնագրի փոփոխություններ",
            t: "Հարթակն իրավունք ունի միակողմանիորեն փոփոխել այս համաձայնագիրը։ Բոլոր փոփոխությունները ուժի մեջ են մտնում կայքում կամ հավելվածում հրապարակվելու պահից։",
        },
        {
            h: "9. Եզրափակիչ դրույթներ",
            t: "Սույն համաձայնագիրը կարգավորվում և մեկնաբանվում է Հայաստանի Հանրապետության օրենսդրության համաձայն։ Վեճերը լուծվում են բանակցությունների միջոցով։",
        },
        {
            h: "10. Կապ մեզ հետ",
            t: "Համաձայնագրի հետ կապված ցանկացած հարցի կամ խնդրի դեպքում խնդրում ենք կապվել մեզ հետ՝ 📧 info.ctrlvolunteering@gmail.com էլեկտրոնային հասցեով։",
        },
    ],
};

const emptyLike = (obj) =>
    Object.keys(obj).reduce((acc, key) => {
        acc[key] = Array.isArray(obj[key]) ? [] : "";
        return acc;
    }, {});

const en = {
    ...emptyLike(hy),
    "nav.about": "About Us",
    "nav.volunteers": "Volunteers",
    "nav.organizations": "Organizations",
    "nav.events": "Events",
    "nav.becomePartner": "Become a Partner",
    "nav.download": "Download",

    "download.appStore.small": "Download on",
    "download.googlePlay.small": "Get it on",

    "hero.eyebrow": "National Volunteering Ecosystem",
    "hero.title": "National Platform for Volunteers",
    "hero.subtitle":
        "Events, rewards, and opportunities right in your pocket. Download the app and join Armenia's volunteering community.",
    "hero.platforms": "Available for iOS and Android",

    "benefits.eyebrow": "Why Us?",
    "benefits.heading": "Why Choose Our App",
    "benefits.sub":
        "Built for volunteers: a simple, fast, and motivating experience.",
    "benefits.allInOne.title": "All in One Place",
    "benefits.allInOne.text":
        "All volunteering opportunities, events, and chances in a single app.",
    "benefits.coins.title": "CTRL Coins",
    "benefits.coins.text": "Participate, collect coins, and level up.",
    "benefits.notify.title": "Instant Notifications",
    "benefits.notify.text":
        "Be the first to know about new events directly on your phone.",
    "benefits.trust.title": "Transparent and Reliable",
    "benefits.trust.text":
        "Verified organizations and a transparent volunteering history.",
    "benefits.community.title": "Active Community",
    "benefits.community.text":
        "Join thousands of volunteers and find your team.",
    "benefits.fast.title": "Fast and Free",
    "benefits.fast.text": "Sign up in a few seconds, completely for free.",

    "features.eyebrow": "Features",
    "features.heading": "What Can You Do With the App?",
    "features.discover.title": "Find Your Volunteering",
    "features.discover.text":
        "Search and find suitable volunteer opportunities by location, field, and your interests.",
    "features.discover.screen": "Search",
    "features.progress.title": "Track Your Progress",
    "features.progress.text":
        "Collect CTRL coins and level up with each participation.",
    "features.progress.screen": "My Profile",
    "features.notify.title": "Instant Notifications",
    "features.notify.text":
        "Be the first to know about new events with notifications sent straight to your phone.",
    "features.notify.screen": "Notifications",
    "features.community.title": "Join the Community",
    "features.community.text":
        "Find teams, collaborate, and get recognized for your contribution.",
    "features.community.screen": "Community",

    "showcase.eyebrow": "The App",
    "showcase.heading": "Your Volunteering Journey in Your Pocket",
    "showcase.desc":
        "The CTRL Events app brings volunteers and organizations together in one simple and convenient platform.",
    "showcase.feature.discover": "Find volunteering opportunities near you",
    "showcase.feature.progress": "Track your progress and level",
    "showcase.feature.notify": "Get notified about new events",
    "showcase.feature.community": "Join teams and earn recognition",

    "footer.tagline": "The national platform for volunteers and organizations.",
    "footer.col.platform": "Platform",
    "footer.col.legal": "Legal",
    "footer.col.social": "Follow Us",
    "footer.copyright": "CTRL Events Volunteering",
    "legal.terms": "Terms of Use",
    "legal.privacy": "Privacy Policy",
    "legal.agreement": "Volunteer Agreement",
    "legal.feedback": "Feedback",

    "volunteers.title": "Volunteers",
    "volunteers.intro":
        "This is where active citizens of Armenia unite to participate in real changes. Here you can create a profile, join programs, and advance on your volunteering journey.",
    "volunteers.progress.title": "Progress",
    "volunteers.progress.text":
        "Every volunteer has their own progression and level scale. Each time you participate in volunteering, you earn CTRL coins. Every 100 coins you collect levels you up. This system motivates you to participate in even more volunteering.",
    "volunteers.top.title": "Our Top Volunteers",
    "volunteers.top.text": "You could be one of them. We are waiting for you.",
    "volunteers.coins": "CTRL coins-",
    "volunteers.error": "Failed to load volunteers.",
    "volunteers.empty": "No volunteers yet. Be the first!",
    "volunteers.cta": "Download the App",

    "feedback.title": "Feedback",
    "feedback.lead":
        "Have a question or suggestion? Write to us, and we'll get back to you.",
    "feedback.success": "Thank you. Your message has been sent.",
    "feedback.name": "Full Name",
    "feedback.name.required": "Please enter your name",
    "feedback.phone": "Phone Number",
    "feedback.phone.required": "Please enter your phone number",
    "feedback.phone.invalid": "Invalid phone number",
    "feedback.email": "Email",
    "feedback.email.required": "Please enter your email",
    "feedback.email.invalid": "Invalid email address",
    "feedback.message": "Message",
    "feedback.message.required": "Please write a message",
    "feedback.message.placeholder": "Your message...",
    "feedback.policy": "I have read and agree to the",
    "feedback.policy.link": "privacy policy",
    "feedback.policy.required": "You must accept the terms",
    "feedback.submit": "Submit",
    "feedback.error": "Could not send. Please try again.",

    // Organization registration (Become a partner form)
    "org.title": "Register your organization",
    "org.lead": "Fill in the form and we will get in touch about partnership.",
    "org.orgName": "Organization name",
    "org.orgName.required": "Please enter the organization name",
    "org.contactName": "Contact person",
    "org.contactName.required": "Please enter a contact person",
    "org.email": "Email",
    "org.email.required": "Please enter an email",
    "org.email.invalid": "Invalid email address",
    "org.phone": "Phone number",
    "org.phone.required": "Please enter a phone number",
    "org.phone.invalid": "Invalid phone number",
    "org.city": "City",
    "org.website": "Website",
    "org.description": "About the organization",
    "org.description.placeholder": "Briefly describe what you do",
    "org.submit": "Submit application",
    "org.success": "Thank you. Your application has been sent.",
    "org.error": "Could not send. Please try again.",

    "page.about.title": "About Us",
    "page.organizations.title": "For Volunteering Organizations",
    "page.events.title": "Events",
    "page.becomePartner.title": "Become a Partner",

    "about.intro.p1":
        "We are creating the first unified, modern, and open platform that connects all volunteers and volunteering organizations in Armenia. Our goal is to build a reliable, transparent, and engaging environment where everyone can find their place to help, grow, and make an impact. We believe that volunteering is not just a charitable act, but a culture that shapes a strong society.",
    "about.intro.items": [
        "real projects,",
        "getting recognition and appreciation for their work,",
        "developing skills and experience,",
        "joining initiatives at local and international levels.",
    ],
    "about.intro.p2":
        "Our team works on the idea that everyone can change the world even with small steps. We are building a system where newcomers easily find their first experience, and experienced volunteers can move forward, become team leaders, or get involved in large projects. Our vision is to create a vibrant volunteering community that promotes social responsibility, innovation, and a culture of mutual help. Join us to build a strong, caring, and proactive Armenia.",
    "about.faqTitle": "Frequently Asked Questions",
    "about.faq": [
        {
            q: "What is the main goal of your platform?",
            a: "To create a unified ecosystem for connecting volunteers and organizations, promoting volunteering culture, and increasing social responsibility.",
        },
        {
            q: "Who is the platform for?",
            a: "For all active citizens, students, and youth in Armenia, as well as public and volunteer organizations.",
        },
        {
            q: "How can I register as a volunteer?",
            a: "Download the CTRL Events app from App Store or Google Play and create your profile.",
        },
        {
            q: "Can I become a team leader or manage a project?",
            a: "Yes, participation and activity increase your level and allow you to take on leadership roles.",
        },
        {
            q: "How can I register as a volunteer?",
            a: "Registration is completed directly in the app via a simple identification process.",
        },
        {
            q: "How can an organization cooperate with you?",
            a: "Organizations can add their profile via the 'Become a Partner' section.",
        },
        {
            q: "Is participation paid?",
            a: "No, the platform is completely free for both volunteers and organizations.",
        },
        {
            q: "Are there competitions or rewards for volunteers?",
            a: "Yes, our 'CTRL coins' system rewards your participation and allows you to level up.",
        },
        {
            q: "How do you ensure program transparency?",
            a: "We verify all registered organizations and provide a feedback system for volunteers.",
        },
    ],

    "org.intro":
        "We unite the entire volunteering ecosystem of Armenia, creating a platform where your organization can work more efficiently, beneficiaries can get better support, and volunteers can grow and become a stronger professional force.",
    "org.whyTitle": "Why join our platform",
    "org.why": [
        {
            label: "Unified management system",
            text: "Manage your entire volunteering structure from one place: register volunteers, divide them into teams, track progress, and get clear reports.",
        },
        {
            label: "Growth in your community engagement",
            text: "Attract new volunteers, present your programs to a large audience, and increase visibility.",
        },
        {
            label: "Tools that will save your time",
            text: "Automated registration, scheduling, workflows, messaging, feedback system, and online certificate issuance.",
        },
        {
            label: "Participation in a national initiative",
            text: "Become part of the country's movement, building a unified culture.",
        },
        {
            label: "Visibility and transparency",
            text: "Showcase your organization's efficiency and completed projects.",
        },
        {
            label: "Access to international opportunities",
            text: "Form partnerships with international structures and offer your members global experiences.",
        },
    ],
    "org.goalTitle": "Our shared goal",
    "org.goal":
        "To create a platform where volunteering organizations can grow, collaborate, and make a greater impact than ever before.",
    "org.cta": "Add my organization",

    "partner.intro":
        "We are building a national volunteering platform that unites thousands of people, organizations, and initiatives. If your organization shares the same values—support, development, and social responsibility—we invite you to join our partner network.",
    "partner.whyTitle": "Why be our partner",
    "partner.why": [
        {
            label: "Help thousands of active citizens",
            text: "Reach a large volunteer community from various fields with different skills.",
        },
        {
            label: "Strengthen your social responsibility",
            text: "Show a measurable contribution to community development.",
        },
        {
            label: "Participate in national and international projects",
            text: "Join joint programs, conferences, and volunteer campaigns.",
        },
        {
            label: "Support the new generation of volunteers",
            text: "Contribute to education, skill development, and international exchanges.",
        },
        {
            label: "Brand visibility",
            text: "Get highlighted on the platform and in promotional materials.",
        },
        {
            label: "Reputation",
            text: "Raise your organization's reputation as a social value creator.",
        },
    ],
    "partner.formsTitle": "Forms of partnership",
    "partner.forms":
        "Financial support (funding programs/events), Sponsorship (prizes, educational trips), Professional support (specialist training), Informational support (media coverage), Joint programs (co-financing or joint implementation).",
    "partner.cta": "Collaborate",

    "events.intro":
        "This is our portfolio. Here you can see the events that volunteers and organizations have participated in.",
    "events.seeMore": "See more",
    "events.cta": "Download the app",
    "eventDetail.back": "All events",
    "eventDetail.notFound": "Event not found",

    "legal.updated": "Last updated: July 4, 2026",
    "terms.intro":
        "Welcome to 'Ctrl Events'. These Terms of Use govern your access to and use of the website and mobile application.",
    "terms.sections": [
        {
            h: "1. Service Description",
            t: "'Ctrl Events' connects volunteers with organizations. The Platform allows users to find volunteering opportunities, register for events, and earn 'CTRL' coins.",
        },
        {
            h: "2. Account and Registration",
            t: "You must create an account with accurate information. You are responsible for safeguarding your password. Creating fake accounts is strictly prohibited.",
        },
        {
            h: "3. User Conduct and Objectionable Content",
            t: "It is forbidden to post offensive, hateful, or explicit material. Zero Tolerance Policy: We immediately remove objectionable content and permanently ban violating users without prior notice.",
        },
        {
            h: "4. Reporting and Moderation",
            t: "Every user can immediately report objectionable content or abusive users. Our moderation team reviews all reports and applies necessary restrictions.",
        },
        {
            h: "5. Management of Volunteering",
            t: "Volunteering is unpaid. Events are either directly managed by the 'CONTROL EVENTS' NGO (where we bear full responsibility) or by third parties (where we act solely as a mediator).",
        },
        {
            h: "6. Intellectual Property",
            t: "The Platform's design, texts, logos, and code are our intellectual property. Copying them without written permission is prohibited.",
        },
        {
            h: "7. Changes to Terms",
            t: "We reserve the right to update these terms periodically. Continued use of the Platform implies acceptance of the new terms.",
        },
        {
            h: "8. Account Termination",
            t: "You may delete your account from your settings. We may also suspend or terminate your account for violating these Terms.",
        },
        {
            h: "9. Contact Us",
            t: "If you have questions, contact us: info.ctrlvolunteering@gmail.com",
        },
    ],

    // Privacy policy
    "privacy.intro":
        "This Privacy Policy explains how we collect, process, store, and protect your personal data when you use the 'Ctrl Events' platform.",
    "privacy.sections": [
        {
            h: "1. What data we collect",
            t: "We collect data that you provide during registration and usage of the platform, specifically: first name, last name, email address, phone number, date of birth, profile picture, as well as the history of your actions and attended events on the platform.",
        },
        {
            h: "2. Purpose of data usage",
            t: "Your data is used to ensure the proper functioning of the platform, coordinate volunteer programs accurately, send you notifications, provide support, and improve our services through statistical analysis.",
        },
        {
            h: "3. Data sharing with third parties",
            t: "We strictly respect your privacy. Your personal data is never sold to third parties. It may be shared with event organizers solely to confirm your participation, or provided to law enforcement agencies only when required by the legislation of the Republic of Armenia.",
        },
        {
            h: "4. Data protection",
            t: "We use modern security measures (encryption, secure servers) to protect your data from unauthorized access, loss, or disclosure.",
        },
        {
            h: "5. Data retention and deletion (Account Deletion)",
            t: "Your data is stored as long as your account is active. You can request the complete deletion of your account and personal data at any time via the app settings or by sending us an email.",
        },
        {
            h: "6. Your rights",
            t: "You have the right to access your data, edit it, restrict its processing, or request full deletion. You also have the right to opt-out of notifications at any time.",
        },
        {
            h: "7. Policy changes",
            t: "We may periodically update this policy. Changes take effect from the moment they are published on the website or application.",
        },
        {
            h: "8. Contact us",
            t: "For questions regarding the Privacy Policy, you can contact us at: 📧 info.ctrlvolunteering@gmail.com.",
        },
        {
            h: "9. Final provisions",
            t: "This policy operates in accordance with the Law of the Republic of Armenia 'On the Protection of Personal Data'.",
        },
    ],

    // Volunteer agreement
    "agreement.intro":
        "This Volunteer Agreement regulates the relationship between the volunteer, the 'Ctrl Events' platform, and event organizing parties. By registering as a volunteer, you accept the following terms.",
    "agreement.sections": [
        {
            h: "1. General provisions",
            t: "Volunteering is carried out by the volunteer's free will, for public benefit, and without expectation of financial remuneration. It does not constitute an employment relationship under labor legislation.",
        },
        {
            h: "2. Volunteer's rights",
            t: "The volunteer has the right to receive full information in advance about the nature and conditions of the work, refuse participation at any time by notifying the organizer, and receive an evaluation, certificate, or letter of recommendation.",
        },
        {
            h: "3. Volunteer's responsibilities",
            t: "The volunteer commits to performing the undertaken work in good faith, following the instructions of organizers and team leaders, adhering to the event schedule, and not damaging the reputation of the organization or event.",
        },
        {
            h: "4. Security and responsibility",
            t: "The volunteer participates in events at their own risk. The platform and organizers commit to providing safe working conditions as much as possible, but bear no direct responsibility for damages caused by the volunteer's negligence or rule violations.",
        },
        {
            h: "5. Code of conduct",
            t: "The volunteer must observe ethical standards and show respect to other volunteers, organizers, and beneficiaries. Being under the influence of alcohol or drugs and violating public order is strictly prohibited.",
        },
        {
            h: "6. Personal data",
            t: "The volunteer's personal data is collected and processed strictly in accordance with our Privacy Policy, exclusively for the purpose of organizing volunteer programs and events.",
        },
        {
            h: "7. Photos and materials",
            t: "By participating in events, the volunteer agrees that photos and videos taken with their participation may be used by the platform and organizers for informational, educational, and non-commercial purposes.",
        },
        {
            h: "8. Agreement changes",
            t: "The platform reserves the right to unilaterally modify this agreement. All changes take effect from the moment they are published on the website or application.",
        },
        {
            h: "9. Final provisions",
            t: "This agreement is governed by and construed in accordance with the legislation of the Republic of Armenia. Disputes shall be resolved through negotiations.",
        },
        {
            h: "10. Contact us",
            t: "If you have any questions or issues related to the agreement, please contact us at 📧 info.ctrlvolunteering@gmail.com",
        },
    ],
};

const ru = {
    ...emptyLike(hy),
    "nav.about": "О нас",
    "nav.volunteers": "Волонтеры",
    "nav.organizations": "Организации",
    "nav.events": "Мероприятия",
    "nav.becomePartner": "Стать партнером",
    "nav.download": "Скачать",

    "download.appStore.small": "Скачать в",
    "download.googlePlay.small": "Доступно в",

    "hero.eyebrow": "Национальная экосистема волонтерства",
    "hero.title": "Национальная платформа для волонтеров",
    "hero.subtitle":
        "Мероприятия, награды и возможности — в твоем кармане. Скачай приложение и присоединяйся к сообществу волонтеров Армении.",
    "hero.platforms": "Доступно для iOS и Android",

    "benefits.eyebrow": "Почему мы?",
    "benefits.heading": "Почему стоит выбрать наше приложение",
    "benefits.sub": "Создано для волонтеров: просто, быстро и с мотивацией.",
    "benefits.allInOne.title": "Всё в одном месте",
    "benefits.allInOne.text":
        "Все волонтерские возможности, мероприятия и проекты в одном приложении.",
    "benefits.coins.title": "CTRL монеты",
    "benefits.coins.text": "Участвуй, копи монеты и повышай свой уровень.",
    "benefits.notify.title": "Мгновенные уведомления",
    "benefits.notify.text":
        "Узнавай о новых мероприятиях первым прямо на телефоне.",
    "benefits.trust.title": "Прозрачность и надежность",
    "benefits.trust.text":
        "Проверенные организации и прозрачная история волонтерства.",
    "benefits.community.title": "Активное сообщество",
    "benefits.community.text":
        "Присоединяйся к тысячам волонтеров и найди свою команду.",
    "benefits.fast.title": "Быстро и бесплатно",
    "benefits.fast.text": "Регистрация за пару секунд, абсолютно бесплатно.",

    "features.eyebrow": "Возможности",
    "features.heading": "Что можно делать в приложении?",
    "features.discover.title": "Найди свое волонтерство",
    "features.discover.text":
        "Ищи и находи подходящие волонтерские вакансии по локации, сфере и своим интересам.",
    "features.discover.screen": "Поиск",
    "features.progress.title": "Отслеживай свой прогресс",
    "features.progress.text":
        "Собирай CTRL монеты и повышай уровень с каждым участием.",
    "features.progress.screen": "Мой профиль",
    "features.notify.title": "Мгновенные уведомления",
    "features.notify.text":
        "Узнавай о новых мероприятиях первым благодаря уведомлениям прямо на телефон.",
    "features.notify.screen": "Уведомления",
    "features.community.title": "Присоединяйся к сообществу",
    "features.community.text":
        "Находи команды, сотрудничай и получай признание за свой вклад.",
    "features.community.screen": "Сообщество",

    "showcase.eyebrow": "Приложение",
    "showcase.heading": "Твой путь волонтера в твоем кармане",
    "showcase.desc":
        "Приложение CTRL Events объединяет волонтеров и организации в одной простой и удобной среде.",
    "showcase.feature.discover": "Находи волонтерские проекты поблизости",
    "showcase.feature.progress": "Следи за своим прогрессом и уровнем",
    "showcase.feature.notify": "Получай уведомления о новых мероприятиях",
    "showcase.feature.community":
        "Присоединяйся к командам и получай признание",

    "footer.tagline": "Национальная платформа для волонтеров и организаций.",
    "footer.col.platform": "Платформа",
    "footer.col.legal": "Правовая информация",
    "footer.col.social": "Подписывайтесь на нас",
    "footer.copyright": "CTRL Events Volunteering",
    "legal.terms": "Условия использования",
    "legal.privacy": "Политика конфиденциальности",
    "legal.agreement": "Соглашение волонтера",
    "legal.feedback": "Обратная связь",

    "volunteers.title": "Волонтеры",
    "volunteers.intro":
        "Здесь объединяются активные граждане Армении, чтобы участвовать в реальных изменениях. Создай профиль, присоединяйся к программам и продвигайся на своем пути волонтера.",
    "volunteers.progress.title": "Прогресс",
    "volunteers.progress.text":
        "У каждого волонтера есть своя шкала прогресса и уровня. За каждое участие ты получаешь CTRL монеты. Каждые 100 собранных монет повышают твой уровень. Эта система мотивирует участвовать в еще большем количестве проектов.",
    "volunteers.top.title": "Наши лучшие волонтеры",
    "volunteers.top.text": "Ты можешь стать одним из них. Мы ждем тебя.",
    "volunteers.coins": "CTRL coins-",
    "volunteers.error": "Не удалось загрузить волонтеров.",
    "volunteers.empty": "Пока нет волонтеров. Стань первым!",
    "volunteers.cta": "Скачать приложение",

    "feedback.title": "Обратная связь",
    "feedback.lead":
        "Есть вопросы или предложения? Напишите нам, и мы с вами свяжемся.",
    "feedback.success": "Спасибо. Ваше сообщение отправлено.",
    "feedback.name": "Имя Фамилия",
    "feedback.name.required": "Пожалуйста, введите имя",
    "feedback.phone": "Номер телефона",
    "feedback.phone.required": "Пожалуйста, введите номер телефона",
    "feedback.phone.invalid": "Неверный номер телефона",
    "feedback.email": "Email",
    "feedback.email.required": "Пожалуйста, введите email",
    "feedback.email.invalid": "Неверный email адрес",
    "feedback.message": "Сообщение",
    "feedback.message.required": "Пожалуйста, напишите сообщение",
    "feedback.message.placeholder": "Ваше сообщение...",
    "feedback.policy": "Я прочитал(а) и принимаю",
    "feedback.policy.link": "политику конфиденциальности",
    "feedback.policy.required": "Необходимо принять условия",
    "feedback.submit": "Отправить",
    "feedback.error": "Не удалось отправить. Пожалуйста, попробуйте ещё раз.",

    // Organization registration (Become a partner form)
    "org.title": "Регистрация организации",
    "org.lead": "Заполните форму, и мы свяжемся с вами по вопросу партнёрства.",
    "org.orgName": "Название организации",
    "org.orgName.required": "Укажите название организации",
    "org.contactName": "Контактное лицо",
    "org.contactName.required": "Укажите контактное лицо",
    "org.email": "Эл. почта",
    "org.email.required": "Укажите эл. почту",
    "org.email.invalid": "Неверный адрес эл. почты",
    "org.phone": "Номер телефона",
    "org.phone.required": "Укажите номер телефона",
    "org.phone.invalid": "Неверный номер телефона",
    "org.city": "Город",
    "org.website": "Веб-сайт",
    "org.description": "Об организации",
    "org.description.placeholder": "Кратко опишите вашу деятельность",
    "org.submit": "Отправить заявку",
    "org.success": "Спасибо. Ваша заявка отправлена.",
    "org.error": "Не удалось отправить. Пожалуйста, попробуйте ещё раз.",

    "page.about.title": "О нас",
    "page.organizations.title": "Для волонтерских организаций",
    "page.events.title": "Мероприятия",
    "page.becomePartner.title": "Стать партнером",

    "about.intro.p1":
        "Мы создаем первую единую, современную и открытую платформу, которая объединяет всех волонтеров и волонтерские организации Армении. Наша цель — построить надежную, прозрачную и вовлекающую среду, где каждый сможет найти свое место, чтобы помогать, развиваться и приносить пользу. Мы верим, что волонтерство — это не просто благотворительный шаг, а культура, формирующая сильное общество.",
    "about.intro.items": [
        "реальных проектах,",
        "получать признание и оценку за свою работу,",
        "развивать навыки и получать опыт,",
        "присоединяться к инициативам на местном и международном уровнях.",
    ],
    "about.intro.p2":
        "Наша команда работает над идеей, что каждый человек может изменить мир даже небольшими шагами. Мы строим систему, в которой новички легко находят свой первый опыт, а опытные волонтеры могут двигаться вперед, становиться лидерами команд или участвовать в крупных проектах. Наше видение — создать живое волонтерское сообщество, которое будет способствовать развитию социальной ответственности, инноваций и культуры взаимопомощи. Присоединяйтесь к нам, чтобы построить сильную, заботливую и инициативную Армению.",
    "about.faqTitle": "Часто задаваемые вопросы",
    "about.faq": [
        {
            q: "Какова главная цель вашей платформы?",
            a: "Создание единой экосистемы для связи волонтеров и организаций, продвижение культуры волонтерства и повышение социальной ответственности.",
        },
        {
            q: "Для кого предназначена платформа?",
            a: "Для всех активных граждан, студентов и молодежи Армении, а также общественных и волонтерских организаций.",
        },
        {
            q: "Как я могу зарегистрироваться в качестве волонтера?",
            a: "Скачайте приложение CTRL Events из App Store или Google Play и создайте свой профиль.",
        },
        {
            q: "Могу ли я стать тимлидом или руководить проектом?",
            a: "Да, участие и активность повышают ваш уровень, позволяя брать на себя лидерские роли.",
        },
        {
            q: "Как я могу зарегистрироваться в качестве волонтера?",
            a: "Регистрация происходит непосредственно в приложении через простую процедуру идентификации.",
        },
        {
            q: "Как организация может сотрудничать с вами?",
            a: "Организации могут добавить свой профиль в разделе «Стать партнером».",
        },
        {
            q: "Участие платное?",
            a: "Нет, платформа полностью бесплатна для волонтеров и организаций.",
        },
        {
            q: "Есть ли конкурсы или награды для волонтеров?",
            a: "Да, наша система «CTRL coins» вознаграждает за участие и позволяет повышать уровень.",
        },
        {
            q: "Как вы обеспечиваете прозрачность программ?",
            a: "Мы проверяем все зарегистрированные организации и предоставляем систему обратной связи.",
        },
    ],

    "org.intro":
        "Мы объединяем всю волонтерскую экосистему Армении, создавая платформу, где ваша организация сможет работать эффективнее, бенефициары — получать более качественную поддержку, а волонтеры — развиваться и становиться сильной профессиональной силой.",
    "org.whyTitle": "Зачем присоединяться к нашей платформе",
    "org.why": [
        {
            label: "Единая система управления",
            text: "Управляйте всей структурой из одного места: регистрируйте волонтеров, делите на команды, отслеживайте прогресс и получайте отчеты.",
        },
        {
            label: "Рост вовлеченности вашего сообщества",
            text: "Привлекайте новых волонтеров, представляйте программы широкой аудитории и повышайте узнаваемость.",
        },
        {
            label: "Инструменты для экономии времени",
            text: "Автоматическая регистрация, расписание, рабочие процессы, обмен сообщениями, система отзывов и онлайн-выдача сертификатов.",
        },
        {
            label: "Участие в национальной инициативе",
            text: "Станьте частью движения страны, выстраивая единую культуру помощи.",
        },
        {
            label: "Видимость и прозрачность",
            text: "Демонстрируйте эффективность организации и реализованные проекты.",
        },
        {
            label: "Доступ к международным возможностям",
            text: "Формируйте партнерства и предлагайте членам организации глобальный опыт.",
        },
    ],
    "org.goalTitle": "Наша общая цель",
    "org.goal":
        "Создать платформу, на которой волонтерские организации смогут расти, сотрудничать и оказывать большее влияние, чем когда-либо прежде.",
    "org.cta": "Добавить мою организацию",

    "partner.intro":
        "Мы строим национальную волонтерскую платформу, которая объединяет тысячи людей, организаций и инициатив. Если ваша организация разделяет ценности поддержки, развития и социальной ответственности, мы приглашаем вас в нашу сеть.",
    "partner.whyTitle": "Зачем быть нашим партнером",
    "partner.why": [
        {
            label: "Помощь тысячам активных граждан",
            text: "Охватите большое волонтерское сообщество с различными навыками.",
        },
        {
            label: "Укрепление социальной ответственности",
            text: "Продемонстрируйте реальный вклад в развитие общества.",
        },
        {
            label: "Участие в национальных и международных проектах",
            text: "Присоединяйтесь к совместным программам и кампаниям.",
        },
        {
            label: "Поддержка нового поколения волонтеров",
            text: "Вносите вклад в обучение и развитие навыков молодежи.",
        },
        {
            label: "Узнаваемость бренда",
            text: "Получите упоминания на платформе и в рекламных материалах.",
        },
        {
            label: "Репутация",
            text: "Повысьте статус организации как создателя социальных ценностей.",
        },
    ],
    "partner.formsTitle": "Формы партнерства",
    "partner.forms":
        "Финансовая поддержка (фонды мероприятий), Спонсорство (призы, поездки), Профессиональная поддержка (обучение), Информационная поддержка (СМИ), Совместные программы (совместная реализация).",
    "partner.cta": "Сотрудничать",

    "events.intro":
        "Это наше портфолио. Здесь представлены мероприятия, в которых принимали участие волонтеры и организации.",
    "events.seeMore": "Показать больше",
    "events.cta": "Скачать приложение",
    "eventDetail.back": "Все мероприятия",
    "eventDetail.notFound": "Мероприятие не найдено",

    "legal.updated": "Последнее обновление: 4 июля 2026 г.",
    "terms.intro":
        "Добро пожаловать в «Ctrl Events». Настоящие Условия использования регулируют ваш доступ к веб-сайту и мобильному приложению и их использование.",
    "terms.sections": [
        {
            h: "1. Описание сервиса",
            t: "«Ctrl Events» объединяет волонтёров и организации. Платформа позволяет находить задачи, регистрироваться на мероприятия и накапливать монеты «CTRL».",
        },
        {
            h: "2. Учётная запись и регистрация",
            t: "Необходимо создать учётную запись, указав точные данные. Вы несёте ответственность за безопасность своего пароля. Создание поддельных учётных записей запрещено.",
        },
        {
            h: "3. Правила поведения и недопустимый контент",
            t: "Запрещается размещать оскорбительные материалы, разжигающие ненависть или непристойные. Абсолютная нетерпимость (Zero Tolerance): мы без предупреждения удаляем недопустимый контент и блокируем нарушителей.",
        },
        {
            h: "4. Жалобы и модерация (Reporting)",
            t: "Каждый пользователь может незамедлительно сообщить (report) о ненадлежащем поведении. Модераторы рассматривают сообщения и применяют блокировки.",
        },
        {
            h: "5. Организация волонтёрской деятельности",
            t: "Работа выполняется на безвозмездной основе. Мероприятия управляются либо напрямую НКО «КОНТРОЛ ИВЕНТС» (где мы несём полную ответственность), либо через третью сторону, где платформа выступает лишь посредником.",
        },
        {
            h: "6. Интеллектуальная собственность",
            t: "Дизайн, тексты, логотипы и код являются нашей интеллектуальной собственностью. Копирование без письменного разрешения запрещено.",
        },
        {
            h: "7. Изменения условий",
            t: "Мы вправе периодически обновлять условия. Продолжение использования означает принятие новых условий.",
        },
        {
            h: "8. Прекращение действия аккаунта",
            t: "Вы можете удалить свою учётную запись в настройках. Мы также можем приостановить её действие в случае нарушения условий.",
        },
        {
            h: "9. Свяжитесь с нами",
            t: "По всем вопросам обращайтесь: info.ctrlvolunteering@gmail.com",
        },
    ],
    // Privacy policy
    "privacy.intro":
        "Настоящая Политика конфиденциальности объясняет, как мы собираем, обрабатываем, храним и защищаем ваши личные данные при использовании платформы «Ctrl Events».",
    "privacy.sections": [
        {
            h: "1. Какие данные мы собираем",
            t: "Мы собираем данные, которые вы предоставляете при регистрации и использовании платформы, в частности: имя, фамилию, адрес электронной почты, номер телефона, дату рождения, фотографию профиля, а также историю ваших действий и посещенных мероприятий на платформе.",
        },
        {
            h: "2. Цель использования данных",
            t: "Ваши данные используются для обеспечения нормальной работы платформы, правильной координации волонтерских программ, отправки вам уведомлений, оказания поддержки и улучшения наших услуг посредством статистического анализа.",
        },
        {
            h: "3. Передача данных третьим лицам",
            t: "Мы строго уважаем вашу конфиденциальность. Ваши личные данные никогда не продаются третьим лицам. Они могут быть переданы организаторам мероприятий только для подтверждения вашего участия или предоставлены правоохранительным органам исключительно в случаях, предусмотренных законодательством Республики Армения.",
        },
        {
            h: "4. Защита данных",
            t: "Мы применяем современные меры безопасности (шифрование, безопасные серверы) для защиты ваших данных от несанкционированного доступа, потери или разглашения.",
        },
        {
            h: "5. Хранение и удаление данных (Account Deletion)",
            t: "Ваши данные хранятся до тех пор, пока ваш аккаунт активен. Вы можете в любой момент запросить полное удаление вашего аккаунта и личных данных через настройки приложения или отправив нам электронное письмо.",
        },
        {
            h: "6. Ваши права",
            t: "Вы имеете право получить доступ к своим данным, редактировать их, ограничивать их обработку или требовать полного удаления. Вы также имеете право в любой момент отказаться от уведомлений.",
        },
        {
            h: "7. Изменения политики",
            t: "Мы можем периодически обновлять эту политику. Изменения вступают в силу с момента их публикации на сайте или в приложении.",
        },
        {
            h: "8. Связь с нами",
            t: "По вопросам, связанным с Политикой конфиденциальности, вы можете связаться с нами по адресу: 📧 info.ctrlvolunteering@gmail.com.",
        },
        {
            h: "9. Заключительные положения",
            t: "Настоящая политика действует в соответствии с Законом Республики Армения «О защите персональных данных».",
        },
    ],

    // Volunteer agreement
    "agreement.intro":
        "Настоящее Соглашение волонтера регулирует отношения между волонтером, платформой «Ctrl Events» и организациями, проводящими мероприятия. Регистрируясь в качестве волонтера, вы принимаете следующие условия.",
    "agreement.sections": [
        {
            h: "1. Общие положения",
            t: "Волонтерская деятельность осуществляется по доброй воле волонтера, в общественно полезных целях и без ожидания финансового вознаграждения. Она не является трудовыми отношениями в понимании трудового законодательства.",
        },
        {
            h: "2. Права волонтера",
            t: "Волонтер имеет право заранее получать полную информацию о характере и условиях работы, отказаться от участия в любой момент, предварительно уведомив организатора, а также получить оценку работы, сертификат или рекомендательное письмо.",
        },
        {
            h: "3. Обязанности волонтера",
            t: "Волонтер обязуется добросовестно выполнять взятую на себя работу, следовать указаниям организаторов и руководителей команд, соблюдать график мероприятия и не наносить ущерб репутации организации или мероприятия.",
        },
        {
            h: "4. Безопасность и ответственность",
            t: "Волонтер участвует в мероприятиях под собственную ответственность. Платформа и организаторы обязуются максимально обеспечить безопасные условия работы, но не несут прямой ответственности за ущерб, возникший в результате неосторожности волонтера или нарушения правил.",
        },
        {
            h: "5. Правила поведения",
            t: "Волонтер обязан соблюдать нормы этики и проявлять уважение к другим волонтерам, организаторам и бенефициарам. Нахождение под воздействием алкоголя или наркотиков, а также нарушение общественного порядка строго запрещены.",
        },
        {
            h: "6. Личные данные",
            t: "Личные данные волонтера собираются и обрабатываются в строгом соответствии с нашей Политикой конфиденциальности исключительно в целях организации волонтерских программ и мероприятий.",
        },
        {
            h: "7. Фотографии и материалы",
            t: "Участвуя в мероприятиях, волонтер соглашается с тем, что фотографии и видео с его участием могут быть использованы платформой и организаторами в информационных, образовательных и некоммерческих целях.",
        },
        {
            h: "8. Изменения соглашения",
            t: "Платформа имеет право в одностороннем порядке вносить изменения в данное соглашение. Все изменения вступают в силу с момента их публикации на сайте или в приложении.",
        },
        {
            h: "9. Заключительные положения",
            t: "Настоящее соглашение регулируется и толкуется в соответствии с законодательством Республики Армения. Споры разрешаются путем переговоров.",
        },
        {
            h: "10. Связь с нами",
            t: "По любым вопросам или проблемам, связанным с соглашением, пожалуйста, свяжитесь с нами по электронной почте 📧 info.ctrlvolunteering@gmail.com",
        },
    ],
};

const translations = { hy, en, ru };

export default translations;
